import fr from './plus_one_French.json';
import countries from './countries.json';
import errors from './errors.json';

export default {
  ...fr,
  ...countries,
  ...errors
};
